'use client'

// ============================================================
// MaintenanceBannerClient - parte interativa do banner cutover
// War room: t-cut07-banner-app
// ============================================================
//
// Renderiza o banner amarelo/laranja sticky no topo + botao dismiss.
// Dismiss persistido em cookie (30 dias) - usuario nao ve de novo na
// mesma versao da mensagem. Mudar `version` (ex: novo scheduled_date)
// faz banner reaparecer pra todos.
//
// Cookie:
//   nome  : ebuz_maintenance_dismiss_v<version>
//   valor : 1
//   path  : /
//   maxage: 30 dias
// ============================================================

import { useEffect, useState } from 'react'

interface Props {
  message: string
  version: string
}

export function MaintenanceBannerClient({ message, version }: Props) {
  const cookieName = `ebuz_maintenance_dismiss_v${version}`
  const [dismissed, setDismissed] = useState(true) // SSR-safe (oculto ate hidratar)

  useEffect(() => {
    const has = document.cookie
      .split(';')
      .some((c) => c.trim().startsWith(`${cookieName}=`))
    setDismissed(has)
  }, [cookieName])

  if (dismissed) return null

  function handleDismiss() {
    const days = 30
    const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString()
    document.cookie = `${cookieName}=1; path=/; expires=${expires}; SameSite=Lax`
    setDismissed(true)
  }

  return (
    <div
      role="alert"
      aria-live="polite"
      data-testid="cutover-maintenance-banner"
      style={{
        backgroundColor: '#fef3c7', // amber-100
        color: '#78350f', // amber-900
        borderBottom: '1px solid #d9770622',
        padding: '10px 16px',
        fontSize: '14px',
        position: 'sticky',
        top: 0,
        zIndex: 60,
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        flexWrap: 'wrap',
      }}
    >
      <span style={{ flex: '1 1 auto', minWidth: 0 }}>
        <strong style={{ marginRight: 8 }}>Manutencao programada:</strong>
        {message}
      </span>

      <a
        href="https://uptime.ebuz.com.br/status/ebuz"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          color: '#78350f',
          textDecoration: 'underline',
          fontWeight: 600,
          flexShrink: 0,
        }}
      >
        Status
      </a>

      <button
        type="button"
        onClick={handleDismiss}
        aria-label="Fechar aviso"
        style={{
          background: 'transparent',
          border: 'none',
          color: '#78350f',
          cursor: 'pointer',
          fontSize: 18,
          lineHeight: 1,
          padding: '0 4px',
          flexShrink: 0,
        }}
      >
        x
      </button>
    </div>
  )
}

export default MaintenanceBannerClient
